<template>
  <el-dialog title="付款通知书详情" width="80%" top="5vh" custom-class="receipt-notice-detail" v-model="dialog.show" :before-close="closeDialog" :close-on-click-modal='false'>
    <el-form :model="dataForm" ref="dataForm" label-position="right" label-width="70px">
      <ab-seal :status="sealText"></ab-seal>
      <el-tabs class="list-tab" v-model="activeName" type="card">
        <el-tab-pane label="费用明细" name="cost">
          <div class="contract-container">
            <div class="head">
              <div class="company">{{dataForm.trusteeIdDesc}}</div>
              <div class="title">{{headText}}</div>
              <div class="btn">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-button_excel"
                  @click="exportFile('Excel')"
                  v-if="$isAuth('customer:account:recNotice:expExcel')"
                  :loading="exportLoading"
                  plain
                >Excel</el-button>

                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-printer"
                  @click="exportFile('Pdf')"
                  v-if="$isAuth('customer:account:recNotice:expPdf')"
                  :loading="exportLoading"
                  plain
                >PDF</el-button>
              </div>
            </div>

            <div class="text">
              <div class="tips" v-if="!audited">预付款通知书费用项目可能不全，请以实际对账单为准！</div>
            </div>

            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="客户名称：">
                  <el-input size="mini" v-model="dataForm.principalIdDesc" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单编号：">
                  <el-input size="mini" v-model="dataForm.custOrderNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="海关汇率：">
                  <el-input size="mini" v-model="dataForm.customsRate" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务费收费标准：" label-width="120px">
                  <el-input size="mini" v-model="dataForm.serviceRate" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="desc">依据双方于{{dataForm.contractDate}}签署的《供应链服务协议》（编号: {{dataForm.paperNumber}}），现对本次订单货物进口情况、应付款项确认如下：</div>

            <div class="module-title">订单信息</div>
            <ab-table
              border
              showOrder
              index-label="序号"
              indexWidth="50"
              maxHeight="226"
              :column-list="orderColumns"
              :table-list="dataForm.receiptCustomsList"
              showSummary
              :summaryMethod="orderSummary">
            </ab-table>

            <div class="module-title">应付明细</div>
            <ab-table
              border
              showOrder
              index-label="序号"
              indexWidth="50"
              maxHeight="226"
              :column-list="costColumns"
              :table-list="dataForm.receiptArSettleItemList"
              :cell-class-name="cellClassName"
              showSummary
              :summaryMethod="costSummary">
            </ab-table>

            <div class="module-title">垫付明细</div>
            <ab-table
              border
              showOrder
              index-label="序号"
              indexWidth="50"
              maxHeight="226"
              :column-list="payColumns"
              :table-list="dataForm.receiptPayApplyList"
              showSummary
              :summaryMethod="paySummary">
            </ab-table>

            <el-row :gutter="10" class="sum-row">
              <el-col :span="7">
                <el-form-item label="（1）税费小计：" label-width="92px">
                  <el-input size="mini" :value="dataForm.taxFeesTotalGroup" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="（2）代杂费小计：" label-width="104px">
                  <el-input size="mini" :value="dataForm.agentFeesTotalGroup" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="（3）已垫货款小计：" label-width="116px">
                  <el-input size="mini" :value="dataForm.adTotalGroup" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" style="margin-top: 5px">
                <el-form-item label="（4）本单应付合计：" label-width="116px">
                  <el-input size="mini" :value="dataForm.payableTotalGroup" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="bank">
              <p class="gray">*请将以上应付款项汇入如下银行账户：</p>
              <p>
                <span>公司名称：{{dataForm.companyName}}</span>
                <span>开户行：{{dataForm.bankName}}</span>
                <span>银行账号：{{dataForm.accountNumber}}</span>
              </p>
              <i
                class="chapter"
                :style="{ backgroundImage: 'url(' + (dataForm.chapterUrl || '') + ')' }"
              ></i>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="物料明细" name="materiel">
          <div class="contract-container">
            <div class="head">
              <div class="company">{{dataForm.trusteeIdDesc}}</div>
              <div class="title">{{headText}}<span>（附件）</span></div>
              <div class="btn">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-button_excel"
                  @click="exportFile('Excel')"
                  v-if="$isAuth('customer:account:recNotice:expExcel')"
                  :loading="exportLoading"
                  plain
                >Excel</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-printer"
                  @click="exportFile('Material')"
                  v-if="$isAuth('customer:account:recNotice:expPdf')"
                  :loading="exportLoading"
                  plain
                >PDF</el-button>
              </div>
            </div>

            <el-row :gutter="20">
              <el-col :span="7">
                <el-form-item label="客户名称：">
                  <el-input size="mini" v-model="dataForm.principalIdDesc" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单编号：">
                  <el-input size="mini" v-model="dataForm.custOrderNo" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="海关汇率：">
                  <el-input size="mini" v-model="dataForm.customsRate" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务费收费标准：" label-width="120px">
                  <el-input size="mini" v-model="dataForm.serviceRate" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <ab-table
              style="margin-top:10px"
              border
              showOrder
              index-label="序号"
              indexWidth="50"
              maxHeight="226"
              :column-list="materielColumns"
              :table-list="dataForm.receiptGoodsList"
              showSummary
              :summaryMethod="materielSummary">
            </ab-table>
          </div>
        </el-tab-pane>
        <div class="contract-record" :style="{ textAlign: activeName === 'cost' ? 'left' : 'right'}">
          <p v-if="dataForm.confirmName">确认人：{{dataForm.confirmName}}&nbsp;/&nbsp;{{dataForm.confirmTime}}</p>
        </div>
      </el-tabs>
    </el-form>

    <template #footer class="dialog-footer">
      <el-button
        type="primary"
        v-if="$isAuth('customer:account:recNotice:confirm') && dataForm.status === '2'"
        @click="confirmFun"
        :loading="btnLoading"
      >确认</el-button>

      <el-button @click="closeDialog">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import calc from '../../utils/calculation'

export default {
  name: 'receipt-notice-detail',
  model: {
    prop: 'dialog'
  },
  props: {
    dialog: {
      type: Object,
      default: {
        show: false
      }
    }
  },
  data () {
    return {
      activeName: 'cost',
      exportLoading: false,
      btnLoading: false,
      dataForm: {
        status: '',
        receiptCustomsList: [],
        receiptArSettleItemList: [],
        receiptPayApplyList: [],
        receiptGoodsList: []
      },

      // 订单信息
      orderColumns: [
        {
          labels: '报关单号',
          props: 'customsNumber',
          widths: 140
        },
        {
          labels: '进口日期',
          props: 'portDateStr',
          widths: 100
        },
        {
          labels: '订单金额',
          props: 'totalAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '报关金额',
          props: 'customsAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '币别',
          props: 'customsCurrencyCode',
          widths: 80
        },
        {
          labels: '待付汇金额',
          props: 'unUsedAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '付汇到期日',
          props: 'shouldDateStr',
          widths: 100
        }
      ],

      // 应付明细
      costColumns: [
        {
          labels: '报关单号',
          props: 'customsNumber',
          widths: 140
        },
        {
          labels: '应付日期',
          props: 'arDateStr',
          widths: 100
        },
        {
          labels: '计费项目',
          props: 'expenseItemName',
          widths: 100
        },
        {
          labels: '币别',
          props: 'settleCurrencyCode',
          widths: 80
        },
        {
          labels: '金额',
          props: 'settleAmount',
          widths: 80,
          type: 'money',
          align: 'right'
        },
        {
          labels: '应付金额',
          props: 'arAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '费用说明',
          props: 'adjustReason',
          widths: 100
        }
      ],

      // 垫付明细
      payColumns: [
        {
          labels: '申请单号',
          props: 'applyNumber',
          widths: 140
        },
        {
          labels: '垫付日期',
          props: 'applyDateStr',
          widths: 100
        },
        {
          labels: '付汇汇率',
          props: 'settleRate',
          widths: 80
        },
        {
          labels: '垫资币别',
          props: 'applyCurrencyCode',
          widths: 80
        },
        {
          labels: '垫资金额',
          props: 'adMoney',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '应付金额',
          props: 'adCnyMoney',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '结算币别',
          props: 'settleCurrencyCode',
          widths: 100
        }
      ],

      // 物料明细
      materielColumns: [
        {
          labels: '货物名称',
          props: 'declareGoodsName',
          widths: 180
        },
        {
          labels: '规格型号',
          props: 'model',
          widths: 160
        },
        {
          labels: '品牌',
          props: 'brand',
          widths: 120
        },
        {
          labels: '数量',
          props: 'qty',
          widths: 80
        },
        {
          labels: '单位',
          props: 'baseUnitName',
          widths: 80
        },
        {
          labels: '单价',
          props: 'price',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '总价',
          props: 'amount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '币别',
          props: 'currencyCode',
          widths: 80
        },
        {
          labels: '关税率',
          props: 'importTariffRate',
          widths: 80
        },
        {
          labels: '海关关税',
          props: 'importTariff',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '海关增值税',
          props: 'importAddedTax',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '消费税',
          props: 'consumeAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '进口服务费',
          props: 'serviceAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '杂费',
          props: 'incidentalAmount',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          labels: '小计',
          props: 'feeTotal',
          widths: 100,
          type: 'money',
          align: 'right'
        }
      ]

    }
  },
  watch: {
    'dialog.id' (val) {
      this.activeName = 'cost'
      this.dataForm = {
        status: '',
        receiptCustomsList: [],
        receiptArSettleItemList: [],
        receiptPayApplyList: [],
        receiptGoodsList: []
      }
      this.getDetailData(val)
    }
  },
  computed: {
    audited () {
      return this.dataForm.status === '2' || this.dataForm.status === '3'
    },
    headText () {
      if (this.audited) {
        return '付款通知书'
      }
      return '预付款通知书'
    },
    sealText () {
      if (this.dataForm.status === '3') {
        return '已确认'
      } else if (this.dataForm.status === '2') {
        return '已复核'
      }
      return ''
    }
  },
  mounted () {
    
  },
  methods: {
    getDetailData (id) {
      if (!id) return
      this.$get('/sms/client/receiptNotice/get', { id }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          data.result.receiptCustomsList.forEach((row, index) => {
            if (index > 0) {
              row.totalAmount = null
            }
          })
          this.dataForm = data.result
        } else {
          this.$message.error(data.message)
        }
      })
    },

    // 订单合计
    orderSummary (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['customsAmount'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return calc.add(prev, curr)
            } else {
              return prev
            }
          }, 0)
          sums[index] = this.$filters.formatMoney(sums[index])
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    cellClassName ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'arAmount' && row.arAmountchange) {
        return 'change-cell'
      }
      return ''
    },

    // 费用合计
    costSummary (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['settleAmount', 'arAmount'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return calc.add(prev, curr)
            } else {
              return prev
            }
          }, 0)
          sums[index] = this.$filters.formatMoney(sums[index])
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    // 付汇合计
    paySummary (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['adMoney', 'adCnyMoney'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return calc.add(prev, curr)
            } else {
              return prev
            }
          }, 0)
          sums[index] = this.$filters.formatMoney(sums[index])
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    // 物料合计
    materielSummary (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['qty', 'amount', 'importTariff', 'importAddedTax', 'consumeAmount', 'serviceAmount', 'incidentalAmount', 'feeTotal'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return calc.add(prev, curr)
            } else {
              return prev
            }
          }, 0)
          if (column.property !== 'qty') {
            sums[index] = this.$filters.formatMoney(sums[index])
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    },

    // 导出文件
    exportFile (type) {
      this.exportLoading = true
      this.$get('/sms/client/receiptNotice/exp' + type, { id: this.dialog.id }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.target = '_blank'
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.result
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        } else {
          this.$message.error(data.message)
        }
        this.exportLoading = false
      })
    },

    // 确认
    confirmFun () {
      this.btnLoading = true
      this.$get('/sms/client/receiptNotice/confirm', { id: this.dialog.id }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message({ message: data.message, type: 'success' })
          this.getDetailData(this.dialog.id)
          this.$emit('refresh')
        } else {
          this.$message.error(data.message)
        }
        this.btnLoading = false
      })
    },

    closeDialog () {
      this.dialog.show = false
      this.dialog.id = ''
    }
  }
}
</script>

<style lang="scss">
.receipt-notice-detail {
  .seal {
    right: 240px !important;
    top: 50px !important;
    .desc {
      top: -73% !important;
    }
  }
  .el-dialog__body {
    padding: 10px;
    color: #333;
  }
  .list-tab {
    margin: 0 -10px;
    .el-tabs__content {
      overflow: visible;
      padding: 0 20px 20px;
    }
  }

  .contract-container {
    position: relative;
    .head {
      position: relative;
      height: 28px;
      line-height: 28px;
      text-align: center;
      .company {
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        height: 28px;
        padding: 0 20px;
        line-height: 28px;
        font-size: 14px;
        background: #F2F3F6;
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        color: #000;
        span {
          font-size: 14px;
        }
      }
      .btn {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .text {
      position: relative;
      margin-top: 10px;
      font-size: 12px;
      color: #000;
      span {
        position: absolute;
        top: 0;
        left: 0;
      }
      .tips {
        text-align: center;
        color: #f00;
      }
    }
    .el-row {
      margin-top: 10px;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-form-item__label {
        margin: 0;
        height: 28px;
        line-height: 28px;
      }
      .el-input__inner {
        font-weight: 600;
        border: none;
        border-bottom: 1px solid #BEBEC4;
        background: none !important;
      }
    }
    .desc {
      margin-top: 10px;
      font-size: 12px;
    }
    .module-title {
      position: relative;
      height: 28px;
      padding-left: 10px;
      margin-top: 10px;
      line-height: 28px;
      font-size: 14px;
      color: #0068B7;
      &:before {
        position: absolute;
        left: 0;
        top: 8px;
        content: "";
        display: inline-block;
        width: 2px;
        height: 12px;
        background: #0068B7;
      }
    }
    .sum-row {
      .el-input__inner {
        font-size: 14px;
        color: #FA7F14 !important;
      }
    }
    .change-cell {
      color: #f00;
    }
    .bank {
      position: relative;
      margin-top: 10px;
      font-size: 12px;
      p {
        margin-top: 4px;
        &.gray {
          color: #999;
        }
      }
      span {
        margin-right: 30px;
      }
      .chapter {
        position: absolute;
        top: -8px;
        left: 60px;
        width: 150px;
        height: 112px;
        overflow: hidden;
        opacity: .5;
        background-position: left center;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
  .contract-record {
    font-size: 12px;
    &.materiel {
      margin-top: 10px;
      text-align: right;
    }
    p {
      margin-top: 4px;
    }
  }
}
</style>
